import { SelectProps, TextField } from '@mui/material';
import React, { PropsWithChildren, useState } from 'react';

export type SelectIEEvent = { target: { value: string } };

export interface SelectIEProps {
  selectedValue: string | undefined;
  SelectProps: SelectProps;
  onChange: (event: SelectIEEvent) => void;
}

export default function SelectIE({
  selectedValue,
  SelectProps,
  onChange,
  children,
  ...props
}: PropsWithChildren<SelectIEProps>) {
  const [isSelectorOpen, setIsSelectorOpen] = useState(false);

  const childrenWithClickHandlers = React.Children.map(children, (child) => {
    if (selectedValue && React.isValidElement(child)) {
      const childProps = child?.props;
      return React.cloneElement(child, {
        onClick: (e: {
          stopPropagation: () => void;
          target: SelectIEEvent;
        }) => {
          e.stopPropagation();
          try {
            onChange({
              ...e,
              target: { ...e.target, value: childProps.value }
            });
          } finally {
            setIsSelectorOpen(false);
          }
        },
        ...childProps
      });
    }
    return child;
  });

  return (
    <TextField
      select={selectedValue !== undefined}
      value={selectedValue}
      SelectProps={{
        ...SelectProps,
        open: isSelectorOpen,
        onOpen: () => setIsSelectorOpen(true),
        onClose: () => setIsSelectorOpen(false)
      }}
      onChange={onChange}
      {...props}
    >
      {childrenWithClickHandlers}
    </TextField>
  );
}
